import { createSlice } from "@reduxjs/toolkit";

const capsulesInitialState = {
  isCapsulesPopupVisible: false,
  hasConfirmedSelection: false,
  selectedCapsules: [],
};

const capsulesSlice = createSlice({
  name: "capsules",
  initialState: capsulesInitialState,
  reducers: {
    toggleCapsulesPopup(state) {
      state.isCapsulesPopupVisible = !state.isCapsulesPopupVisible;
    },
    confirmedSelection(state) {
      state.hasConfirmedSelection = true;
      state.isCapsulesPopupVisible = !state.isCapsulesPopupVisible;
    },
    selectCapsules(state, action) {
      const productMasterObject = action.payload;

      const { platformId, quantity = 0 } = productMasterObject;

      const existing = state.selectedCapsules.find((item) => item.platformId === platformId);

      if (existing) {
        if (quantity === 0) {
          state.selectedCapsules = state.selectedCapsules.filter(
            (capsule) => capsule.platformId !== platformId
          );
        } else {
          state.selectedCapsules = state.selectedCapsules.map((capsule) =>
            capsule.platformId === platformId ? { ...capsule, quantity } : capsule
          );
        }
      } else {
        state.selectedCapsules.push({ ...productMasterObject, quantity });
      }
    },
  },
});

export const { toggleCapsulesPopup, confirmedSelection, selectCapsules } = capsulesSlice.actions;

export default capsulesSlice.reducer;
